
<style>
.custom-dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-btn {
  background: linear-gradient(90deg, #C8102E, #8A1538);
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
}
.dropdown-btn:hover {
  background: linear-gradient(90deg, #8A1538, #C8102E);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

/* Dropdown menu */
.dropdown-content {
  position: absolute;
  top: 110%;
  right: 0;
  background-color: #fff;
  min-width: 200px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  z-index: 99;
  overflow: hidden;
  animation: fadeIn 0.3s ease-in-out;
}

.dropdown-content a {
  display: block;
  color: #333;
  padding: 10px 14px;
  text-decoration: none;
  font-weight: 500;
  transition: background 0.2s, color 0.2s;
}

.dropdown-content a:hover {
  background-color: #f7f7f7;
  color: #C8102E;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* --- Layout container --- */
.right-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-wrap: nowrap;
}


/* Responsive */
@media (max-width: 767px) {
  .title-track {
    flex-direction: column;
    text-align: center;
    gap: 10px;
  }

  .right-actions {
    flex-direction: row;
    justify-content: center; /* ✅ keeps both buttons centered on one line */
    align-items: center;
    flex-wrap: nowrap;
    width: 100%;
  }

  .track-link,
  .dropdown-btn {
    width: auto;
    flex: 1 1 auto;
    text-align: center;
    white-space: nowrap;
  }

  /* ✅ Center dropdown directly under the button */
  .custom-dropdown {
    position: relative;
  }
  .custom-dropdown .dropdown-content {
    left: 50%;
    right: auto;
    transform: translateX(-50%);
    top: 110%;
    width: 220px;
  }
}

.password-wrapper {
  position: relative;
}

.password-toggle {
  position: absolute;
  top: 38px; /* adjust based on input height */
  right: 12px;
  cursor: pointer;
  font-size: 18px;
  user-select: none;
  transition: 0.2s;
}

.password-toggle:hover {
  transform: scale(1.1);
}
p {
    color: #636467 ;
    line-height: 1.7em ;
}
h4 {
    display: block;
    margin-block-start: 1.33em;
    margin-block-end: 1.33em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    unicode-bidi: isolate;
}

</style>
<template>

    <TopBar />
    <Toast ref="toast" />

        <!-- Main content -->
        <main class="main-content-container"  >
          <div class="container">
            <h2 class="head-h2">Visa Medicals- Terms & Conditions</h2>

            <div>
                <p>The KIMSHEALTH Online Appointment services for Visa Medicals available on the Website is to provide easy access to choose the date and time of appointment for Visa Medicals according to your convenience. This service does not, in any way constitute an invitation or recommendation to avail consultation Services for KIMSHEALTH Doctors. KIMSHEALTH Online Appointment services advices the users to make an independent choice of date and time for their Visa Medical Appointment. Terms 'you' and 'your' hereafter refers to the user both registered and unregistered who is using/browsing through the KIMSHEALTH Online Appointment services and/or partner websites and/or availing any of the services from KIMSHEALTH Online Appointment services.</p>

                <ul>
                    <li>1, Information and Documents required:</li>
                    <ul>
                        <li><p>You are solely responsible for the medical, health and personal information you provide in KIMSHEALTH Online Appointment services.</p></li>
                        <li><p>User discretion is advised while submitting/uploading your required personal documents like passport copy(with at least 6 months validity), Form IMM1017 E/Express Entry Invitation/Referral letter with HAP ID/NZHR Form for each of the members availing the Visa Medical services.</p></li>
                        <li><p>KIMSHEALTH Online Appointment services are available for use for children, but the Registered Member for all applicants under the age of 18 must be the applicant’s parent or legal guardian. If you register as the parent or legal guardian on behalf of a minor, you will be fully responsible for complying with these Terms of Use.</p></li>
                        <li><p>If the information provided by you is false/deceptive/inaccurate or misleading, KIMSHEALTH Online Appointment services reserves the right to cancel your appointment without assuming any liability whatsoever. Hence, it is advised to submit/upload all relevant and accurate information on the portal.</p></li>
                        <li><p>The information provided by you will be used for advance registration in the eMedical online portal of Immigration and in the KIMSHEALTH hospital information system.</p></li>
                        <li><p>The information provided by you can be kept with KIMSHEALTH Online Appointment services indefinitely and can be used without revealing your identity</p></li>
                    </ul>
                </ul>

                <ul>
                    <li>2, Consultation and InvestigationRequirement:</li>
                    <ul>
                        <li><p>The Appointment services available on the website shall be provided to you on the date and time chosen by you in the KIMSHEALTH Website, subject to the availability of slot.</p></li>
                        <li><p>You understand and acknowledge that blood tests, Xrays or consultations done outside will not be applicable for Visa Medicals and cannot be uploaded into your case file.</p></li>
                        <li><p>In case of previous medical history or surgeries done in the past, please bring all related medical reports when you come for the appointment.</p></li>
                        <li><p>Covid 19 vaccination records and Immunization records for children should be brought on the day of appointment.</p></li>
                        <li><p>Users are advised to use their discretion for following the advice obtained, post consultation from the Panel Doctors.</p></li>
                        <li><p>KIMSHEALTH Online Appointment services are not meant in any way for emergency and life-threatening conditions.</p></li>
                    </ul>
                </ul>
                

                <ul>
                    <li>3, Electronic Payments</li>
                    <ul>
                        <li><p>Appointment would be provided to you, upon payment of Rs 2,500/- (Rupees Two Thousand Five Hundred Only) towards appointment service charges for UK, for Rs 1500/- (Rupees One Thousand Five Hundred Only) as advance for Canada and for Rs 1500/- (Rupees One Thousand Five Hundred Only) as advance for New Zealand, Australia.</p></li>
                        <li><p>The charges mentioned supra may vary in case of any need to conduct additional tests, in case of any possibility of medical issues or diagnosis of medical issues in the medical examination by the doctor.</p></li>
                        <li><p>KIMSHEALTH Online Appointment services offers online mode of payment for an advance amount. You may use internet banking or debit/credit card for making payment for Visa Medical advance charges. You shall be directed to our trusted payment gateway partners once you proceed to make payment of Advance Service Fees. The balance Visa Medical Fees can be paid as card payment or cash on the day of appointment at the Registration counter.</p></li>
                        <li><p>KIMSHEALTH Online Appointment services shall not be liable in any manner whatsoever, if incorrect or inaccurate credit / debit card details are provided by you for making the payment of Visa Medicals Advance Fees or you use a credit/ debit card which is not lawfully owned by you or if you permit a third party to use your password or other means to access your account</p></li>
                        <li><p>KIMSHEALTH Online Appointment services shall keep the aforesaid information confidential at all times and shall not utilize and share the same with any of the third parties unless is an authorized third-party website and / or required by law regulation or court order</p></li>
                    </ul>
                </ul>

                <ul>
                    <li>4, Use of Content &Copyright:</li>
                    <ul>
                        <li><p>KIMSHEALTH Online Appointment services owns the website as well the intellectual property contained thereon, including all programs, processes, designs, software, technologies, trademark, trade names, inventions and materials therein and all the services offered by the doctors / physicians or others on the Website.</p></li>
                        <li><p>You shall not use the content available on the website without the prior written permission of KIMSHEALTH Online Appointment services.</p></li>
                    </ul>
                </ul>

                <ul>
                    <li>5, Privacy and Security:</li>
                    <ul>
                        <li><p>KIMSHEALTH Online Appointment services uses secure encryption technology to keep your information safe and secured at all time. KIMSHEALTH is committed towards maintaining the privacy of the information uploaded by you on the website and complies with the industry standard security safeguards for the purpose of securing the website and the information provided/uploaded by you.</p></li>
                        <li><p>KIMSHEALTH Online Appointment services uses all reasonable endeavours to ensure the integrity of the online payment facility’s security. Despite our endeavours, breaches of security and confidentiality could occur. You acknowledge that we are not liable for any loss suffered by you as a result of any breaches in security</p></li>
                    </ul>
                </ul>

                <ul>
                    <li>6, Indemnity:</li>
                    <ul>
                        <li><p>You agree and undertake to indemnify and keep indemnified KIMSHEALTH Online Appointment services, the concerned Panel Doctor and KIMSHEALTH for any losses, costs, charges and expenses including reasonable attorney fees that the concerned Panel Doctor and KIMSHEALTH may suffer on account of faulty judgement /interpretation errors / perception error arising from (i)your failure to provide correct and / or complete clinical information / history about the applicant in timely and clinically appropriate manner; or (ii)suppression of material facts; or your failure to provide relevant clinical information about the applicant; or (iv) misinterpretation of the advice / prescription / diagnosis by you; or (v) failure to follow doctor’s advice / prescription by you; or (b) incorrect or inaccurate credit / debit card details provided by you; or (c) using a credit / debit card which is not lawfully owned by you; or (d) if you permit a third party to use your password or other means to access your account</p></li>
                    </ul>
                </ul>

                <ul>
                    <li>7, Disclaimer:</li>
                    <ul>
                        <li><p>KIMSHEALTH Online Appointment services provides the services on “as is” basis and expressly disclaims all representations, warranties or conditions of any kind, either expressed or implied, as to the operations of the website, the information, content, service provided through or in connection with the website</p></li>
                        <li><p>In no event shall KIMSHEALTH be responsible for any third-party misuse for the data and for any acts, deeds and circumstances beyond the control of the management of KIMSHEALTH Online Appointment services.</p></li>
                        <li><p>You agree and acknowledge that you are solely responsible for your conduct.</p></li>

                    </ul>
                </ul>

                <ul>
                    <li>8, Limitations of liability:</li>
                    <ul>
                        <li><p>In no event shall KIMSHEALTH Online Appointment services be liable for any direct, indirect, punitive, incidental, special or consequential damages or any damages whatsoever including without limitations, damages for loss of use, data or profits, arising out of or in any way connected with the use of KIMSHEALTH Online Appointment services.</p></li>

                    </ul>
                </ul>

                <ul>
                    <li>9, Termination:</li>
                    <ul>
                        <li><p>This arrangement may be terminated by either party at any time, with or without cause.</p></li>
                        <li><p>KIMSHEALTH Online Appointment services reserves the right to refuse the use of services immediately in case your conduct is deemed by KIMSHEALTH Online Appointment services to be in contravention of applicable acts, laws, rules and regulations or considered to be unethical / immoral</p></li>

                    </ul>
                </ul>

                <ul>
                    <li>10, Modification of Terms and Conditions of Service:</li>
                    <ul>
                        <li><p>KIMSHEALTH Online Appointment services may at any time, without any prior notification to you, modify these terms of conditions.</p></li>
                        <li><p>Please review the latest version of the terms and conditions before proceeding to avail the service.</p></li>
                        <li><p>If you continue to use the service, it shall be deemed that you agree and abide by the modified terms and conditions.</p></li>
                        <li><p>For proper communication of the services, KIMSHEALTH would require the Users to provide a phone number with whatsapp facility to KIMSHEALTH, and any information/details sent to the said number, would be construed as information/communication duly served for the purpose.</p></li>

                    </ul>
                </ul>

                <ul>
                    <li>11, General Terms and Conditions:</li>
                    <ul>
                        <li><p>This agreement shall be governed by the laws of India and shall be subject to the exclusive jurisdiction of the courts at Thiruvananthapuram.</p></li>
                        <li><p>KIMSHEALTH Online Appointment services makes no representation that the services are appropriate for applicants in any other location except in KIMSHEALTH Trivandrum.</p></li>
                        <li><p>If any part of the agreement is determined to be invalid or unenforceable pursuant to applicable law then the said provision will be superseded by a valid, enforceable provision and the remainder of the agreement shall continue in effect.</p></li>
                        <li><p>You acknowledge that the relationship created through your use of this website shall be of principal to principal. You shall not represent yourself as a representative agent or employee of KIMSHEALTH Online Appointment services.</p></li>
                        <li><p>You represent and warrant that you are not a minor (i.e., you are above 18 years of age) and that you are competent and eligible to enter into legally binding agreement.</p></li>

                    </ul>
                </ul>
                
            </div>

          </div>
        </main>

    <Footer />



    <!-- Modal -->
    <div class="modal fade" id="agentRegistrationModal" tabindex="-1" aria-labelledby="agentRegistrationModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-right">
            <div class="modal-content p-0" style="overflow: hidden;">

            <!-- Modal Header -->
            <div class="modal-header text-white" style="background-color: #c62828; display: flex; justify-content: space-between; align-items: center;">

                <!-- Left: Title -->
                <h5 class="modal-title" id="agentRegistrationModalLabel">Agent Registration</h5>

                <!-- Right: Logo + Close Button -->
                <div class="d-flex align-items-center">
                    <!-- Logo -->
                    <img src="@/assets/Images/Logo/Footer Logo.png" alt="Logo" style="height: 40px; margin-right: 10px;">
                    
                    <!-- Close Button -->
                    <button type="button" class="btn-close btn-close-white" @click="closeRegAndOpenSignIn" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

            </div>


            <!-- Modal Body -->
            <div class="modal-body">
                <form @submit.prevent="handleRegister">
                      <div class="row">
                          <!-- Company Name -->
                          <div class="col-md-6 mb-3">
                              <label for="companyName" class="form-label">Business/Agency Name</label><span class="text-danger">*</span>
                              <input 
                                  type="text" 
                                  id="companyName" 
                                  class="form-control" 
                                  v-model.trim="form.companyName" 
                                  :class="{'is-invalid': errors.companyName}"
                                  placeholder="Business/Agency">
                              <div class="invalid-feedback">{{ errors.companyName }}</div>
                          </div>

                          <!-- Full Name -->
                          <div class="col-md-6 mb-3">
                              <label for="agentName" class="form-label">Full Name</label><span class="text-danger">*</span>
                              <input 
                                  type="text" 
                                  id="agentName" 
                                  class="form-control" 
                                  v-model.trim="form.fullName" 
                                  :class="{'is-invalid': errors.fullName}"
                                  placeholder="Enter your full name">
                              <div class="invalid-feedback">{{ errors.fullName }}</div>
                          </div>

                          <!-- Email -->
                          <div class="col-md-6 mb-3">
                              <label for="agentEmail" class="form-label">Email Address</label><span class="text-danger">*</span>
                              <input 
                                  type="email" 
                                  id="agentEmail" 
                                  class="form-control" 
                                  v-model.trim="form.email" 
                                  :class="{'is-invalid': errors.email}"
                                  placeholder="example@gmail.com">
                              <div class="invalid-feedback">{{ errors.email }}</div>
                          </div>

                          <!-- Phone -->
                          <div class="col-md-6 mb-3">
                              <label for="agentPhone" class="form-label">Phone Number</label><span class="text-danger">*</span>
                              <input 
                                  type="tel" 
                                  id="agentPhone" 
                                  class="form-control" 
                                  :class="{'is-invalid': errors.phone}"
                                  ref="phoneInput" 
                                  placeholder="(000) 000-0000">
                              <div class="invalid-feedback d-block">{{ errors.phone }}</div>
                          </div>

                          <!-- Aadhar -->
                          <div class="col-md-6 mb-3">
                              <label for="aadharNumber" class="form-label">Aadhar Number</label><span class="text-danger">*</span>
                              <input 
                                  type="text" 
                                  id="aadharNumber" 
                                  class="form-control" 
                                  v-model.trim="form.aadharNumber" 
                                  :class="{'is-invalid': errors.aadharNumber}"
                                  placeholder="Aadhar Number">
                              <div class="invalid-feedback">{{ errors.aadharNumber }}</div>
                          </div>

                          <!-- Full Name -->
                          <div class="col-md-6 mb-3">
                              <label for="gstNumber" class="form-label">GST Number</label>
                              <input 
                                  type="text" 
                                  id="gstNumber" 
                                  class="form-control" 
                                  v-model.trim="form.gstNumber" 
                                  :class="{'is-invalid': errors.gstNumber}"
                                  placeholder="GST Number">
                              <div class="invalid-feedback">{{ errors.gstNumber }}</div>
                          </div>

                          <!-- Address -->
                          <div class="col-md-12">
                              <label for="address" class="form-label">Address</label>
                              <textarea
                                  id="address"
                                  class="form-control"
                                  v-model.trim="form.address"
                                  :class="{'is-invalid': errors.address}"
                                  placeholder="Enter Your Address..."
                                  rows="3"
                              ></textarea>
                              <div class="invalid-feedback">{{ errors.address }}</div>
                          </div>

                      </div>

                      <br>
                      <!-- Confirmation Checkbox -->
                      <div class="col-12 mb-3">
                          <div 
                            class="form-check p-3 border rounded-4 d-flex align-items-start gap-2" 
                            :class="{'border-danger': errors.confirmation}" 
                            style="background-color: #fff5f5; box-shadow: 0 2px 6px rgba(0,0,0,0.05);">
                            
                            <!-- Checkbox -->
                            <input class="form-check-input mt-1" type="checkbox" 
                              id="confirmationCheck" v-model="form.confirmation"
                              :class="{'is-invalid': errors.confirmation}" 
                              style="width: 20px; height: 20px;">
                            
                            <!-- Label -->
                            <label class="form-check-label fw-normal" for="confirmationCheck" 
                              style="font-size: 0.875rem; line-height: 1.5;">
                              I hereby confirm that I shall not be entitled to any commission for visa appointment bookings from KIMS. I and KIMS are completely different parties and do not hold any link.
                            </label>

                          </div>
                          <!-- Error Message -->
                          <div class="invalid-feedback d-block" v-if="errors.confirmation">
                            {{ errors.confirmation }}
                          </div>
                      </div>

                </form>
            </div>

            <!-- Modal Footer -->
            <div class="modal-footer" style="background-color: #c62828;">
                <button type="button" class="btn btn-light" style="cursor: pointer; z-index: 1056;" @click="closeRegAndOpenSignIn" data-bs-dismiss="modal">Close</button>
                <button type="button" :disabled="isSignUpLoading" class="btn btn-light" @click="handleRegister">
                  <span 
                    v-if="isSignUpLoading" 
                    class="spinner-border spinner-border-sm" 
                    role="status" 
                    aria-hidden="true">
                  </span>
                  <span>{{ isSignUpLoading ? 'Wait...' : 'Register' }}</span>
                </button>
            </div>

            </div>
        </div>
    </div>

    <!-- Sign In Modal -->
    <div class="modal fade" id="agentSignInModal" tabindex="-1" aria-labelledby="signInModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content shadow-lg border-0 rounded-4 overflow-hidden">

          <!-- Header (Compact) -->
          <div class="modal-header py-3 px-3 text-white"
              style="background: linear-gradient(135deg, #c62828, #b71c1c); display: flex; justify-content: space-between; align-items: center;">
            <h5 class="modal-title fw-bold mb-0" id="signInModalLabel">Sign In</h5>
            <div class="d-flex align-items-center">
              <img src="@/assets/Images/Logo/Footer Logo.png" alt="Logo" style="height: 30px; margin-right: 10px;">
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close" style="scale: 1.3;"></button>
            </div>
          </div>


          <!-- Body (Compact) -->
          <div class="modal-body py-3 px-3">
            <form @submit.prevent="handleSignIn">
              <!-- Email -->
              <div class="mb-3">
                <label for="signin-email" class="form-label fw-semibold">Email Address</label>
                <input 
                  type="email" 
                  id="signin-email" 
                  :class="['form-control rounded-2', errors.email ? 'is-invalid' : '']" 
                  v-model.trim="signInForm.email" 
                  placeholder="you@example.com" 
                  >
                  <div v-if="errors.email" class="invalid-feedback">{{ errors.email }}</div>
              </div>

              <!-- Password -->
              <div class="mb-3 password-wrapper">
                <label for="signin-password" class="form-label fw-semibold">Password</label>
                <input 
                  :type="showPassword ? 'text' : 'password'"
                  id="signin-password" 
                  :class="['form-control rounded-2 pe-5', errors.password ? 'is-invalid' : '']" 
                  v-model.trim="signInForm.password" 
                  placeholder="••••••••" 
                  >
                <!-- Custom SVG Icon -->
                <!-- Eye toggle using text icon -->
                <span class="password-toggle" @click="togglePassword">
                  <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                </span>
                  <div v-if="errors.password" class="invalid-feedback">{{ errors.password }}</div>
              </div>

              <!-- Forgot password -->
              <div class="d-flex justify-content-between align-items-center mb-3">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="" id="rememberMe">
                  <label class="form-check-label" for="rememberMe">
                    Remember me
                  </label>
                </div>
                <a href="#" class="text-decoration-none text-danger small"></a>
              </div>

              <!-- Button with Loading -->
              <div class="d-grid">
                  <button 
                    type="submit" 
                    class="btn rounded-2 d-flex justify-content-center align-items-center gap-2"
                    :disabled="isLoading"
                    style="
                      background: linear-gradient(135deg, #c62828, #b71c1c);
                      border: none;          /* remove border */
                      box-shadow: none;      /* remove focus/active shadow */
                      color: white;
                    "
                  >
                    <span 
                      v-if="isLoading" 
                      class="spinner-border spinner-border-sm" 
                      role="status" 
                      aria-hidden="true">
                    </span>
                    <span>{{ isLoading ? 'Signing In...' : 'Sign In' }}</span>
                  </button>
              </div>
            </form>
          </div>



          <!-- Footer -->
          <div class="modal-footer justify-content-center bg-light">
            <p class="mb-0 small">Don’t have an account? 
              <a href="javascript:void(0)" @click="openRegistrationFromSignIn" class="text-danger fw-semibold">Create one</a>

            </p>
          </div>

        </div>
      </div>
    </div>

    <!-- otp verification -->
    <div class="modal fade" id="otpAgentRegisterModal" tabindex="-1" aria-labelledby="otpModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content p-4 rounded-4">

                <!-- Close button -->
                <button type="button" class="btn-close position-absolute top-0 end-0 m-3" style="cursor: pointer; z-index: 1056;" @click="closeOtpModal" aria-label="Close"></button>


                <div class="modal-body">
                    <img src="@/assets/Images/Logo/kims-logo.png" alt="KIMSHEALTH" class="mb-3" style="max-width:260px;">
                    <p class="otp_text mb-4">Please enter the OTP received on your email address</p>
        
                    <div class="d-flex justify-content-center mb-3 gap-1 otp-input-group flex-wrap justify-content-between">
                    <input
                        v-for="(digit, index) in otp"
                        :key="index"
                        type="text"
                        class="form-control otp-box text-center"
                        maxlength="1"
                        v-model="otp[index]"
                        @input="focusNext(index, $event)"
                        @keydown.backspace="focusPrev(index, $event)"
                        ref="otpInputs"
                    />
                    </div>
        
                    <small v-if="errors.otpError" class="text-danger">{{ errors.otpError }}</small>
        
                    <a class="btn btn-danger w-100" @click="validationMain(registeredEmail)" :disabled="loading || otpIncomplete">
                      <span v-if="!loading && !resendloading">Confirm</span>
                      <span v-else-if="resendloading">
                        <i class="fa fa-spinner fa-spin"></i> Resending...
                      </span>
                      <span v-else>
                        <i class="fa fa-spinner fa-spin"></i> Processing...
                      </span>
                    </a>
        
                    <div class="d-flex justify-content-between mt-3">
                        <span class="resend">Resend OTP in <span class="timer" :key="formattedTime">{{ formattedTime }}</span></span>
                        <a href="#" 
                          class="resend_btn text-decoration-none" 
                          @click.prevent="handleResend(registeredEmail)" 
                          :class="{'text-muted': timer > 0 || resendloading, 'text-danger': timer === 0 && !resendloading}" 
                          :style="(timer > 0 || resendloading) ? 'pointer-events: none;' : 'pointer-events: auto;'">
                          <span v-if="!resendloading">Resend</span>
                          <span v-else>
                              <i class="fa fa-spinner fa-spin"></i> Resending...
                          </span>
                        </a>

                    </div>
                </div>

          </div>
        </div>
    </div>

    


</template>
<script>
import { ref } from 'vue';
import TopBar from '@/components/Home/Header/TopBar.vue';
import Footer from '@/components/Home/Footer/DownBar.vue';
import Swal from 'sweetalert2';
import { AgentSignUp, AgentVerifyOTP, AgentOTPResend, AgentSignIn, AgentLogout } from '@/api/Agent/sign';
import { useAgentStore } from '@/store/agent';
import Toast from '@/components/Toast/agentToast.vue';
import { useRouter } from 'vue-router';
export default {
    name: 'TermsAndConditions',
    components: {
        TopBar,
        Footer,
        Toast,
    }, 
    data() {
        return {
            LangingHomePage : '/',
            trackAppointment : '/trackAppointment',
            form: {
                  companyName: '',
                  fullName: '',
                  email: '',
                  phone: '',
                  aadharNumber: '',
                  gstNumber: '',
                  address: '',
                  confirmation: false,
              },
              errors: {},
              signInForm: {
                email: '',
                password: ''
              },
              isLoading: false,
              isSignUpLoading: false,
              otp: Array(5).fill(''),
              errors: { otpError: '' },
              loading: false,
              resendloading: false,
              timer: 180,           // 3 minutes in seconds
              formattedTime: '',
              registeredEmail: '',
              otpTimerInterval: null,
              showDropdown: false,
              showPassword: false,
              isAgentLoggedIn: false,
              agentName: '',
              toast: null,
        };
    },
    computed: {
        otpIncomplete() {
          // Assuming `this.otp` is an array of OTP digits
          return this.otp.some(digit => digit === '' || digit == null);
        }
      },
      mounted() {
          const input = this.$refs.phoneInput;
          this.iti = window.intlTelInput(input, {
          initialCountry: 'in', 
          onlyCountries: ['in'], // only india other wise comment it
          separateDialCode: true,
          utilsScript:
              'https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js',
          });

          input.addEventListener('change', this.updatePhone);
          input.addEventListener('blur', this.updatePhone);

          const otpModalEl = document.getElementById('otpAgentRegisterModal');
          otpModalEl.addEventListener('shown.bs.modal', () => {
            //console.log("OTP Modal opened — timer restarting");
            this.resetOtpTimer();
          });
          document.addEventListener('click', this.handleClickOutside);

          this.checkAgentLogin()
      },
      beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
      },
      methods: {
          updatePhone() {
              // Get national number (may include leading 0)
              let nationalNumber = this.iti.getNumber(intlTelInputUtils.numberFormat.NATIONAL);
              // Remove all non-digit characters
              nationalNumber = nationalNumber.replace(/\D/g, '');
              // Remove leading 0 if present
              if (nationalNumber.startsWith('0')) {
                  nationalNumber = nationalNumber.slice(1);
              }
              this.form.phone = nationalNumber;
              //console.log('this.form.phone : ', this.form.phone);
          },


          handleRegister() {
              this.errors = {}; // reset

              if (!this.form.companyName) this.errors.companyName = 'Company Name is required';
              if (!this.form.fullName) this.errors.fullName = 'Full Name is required';
              if (!this.form.email) this.errors.email = 'Email is required';
              else if (!this.validateEmail(this.form.email)) this.errors.email = 'Enter a valid email';
              if (!this.form.phone) this.errors.phone = 'Phone Number is required';
              else if (this.form.phone.length !== 10) this.errors.phone = 'Enter a valid 10-digit number';
              // --- Conditional Aadhar Validation ---
              if (!this.form.aadharNumber) this.errors.aadharNumber = 'Aadhar Number is required';
              else if (!this.validateAadhar(this.form.aadharNumber)) this.errors.aadharNumber = 'Enter a valid 12-digit Aadhar number';
              // --- Conditional GST Validation ---
              if (this.form.gstNumber) {
                  if (!this.validateGST(this.form.gstNumber)) {
                  this.errors.gstNumber = 'Enter a valid GST number';
                  }
              }

              if (this.form.address) {
                  if (!this.form.address.length > 255) {
                      this.errors.address = 'The address exceeded maximum.';
                  }
              }

              if (!this.form.confirmation) {
                this.errors.confirmation = 'You must confirm before submitting';
              }


              if (Object.keys(this.errors).length === 0) {
                  ///console.log('Form Submitted:', this.form);
                  Swal.fire({
                      title: 'Confirm Registration',
                      text: 'Please check the details you entered carefully. Make sure everything is correct before submitting.',
                      showCancelButton: true,
                      confirmButtonColor: '#d33',
                      cancelButtonColor: '#3085d6',
                      confirmButtonText: 'Yes, submit it!',
                      cancelButtonText: 'Cancel'
                  }).then(async (result) => {
                    if (result.isConfirmed) {
                      try {
                        this.isSignUpLoading = true;
                          
                        //const payload = {
                        const name = this.form.fullName;
                        const email = this.form.email;
                        const phone = (this.form.phone || "").replace(/\D/g, "");
                        const agency_name = this.form.companyName;
                        const aadhaar = (this.form.aadharNumber || "").replace(/\D/g, "");
                        const gst_number = this.form.gstNumber || "";
                        const address = this.form.address || "";
                        ///};
                        //console.log('Final payload going to API:', JSON.stringify(payload, null, 2));
                        //  Call your API or sign-up function here
                        const response = await AgentSignUp(name,email,phone,agency_name,aadhaar,gst_number,address);
                        ///console.log('Form response:', JSON.stringify(response, null, 2));

                        // Check response status
                        if (response.status === 200) {
                          //console.log("Response data:", JSON.stringify(response.data, null, 2));
                              
                          if (response.data.success === true) {
                            Swal.fire({
                              title: 'Registration Successful!',
                              //text: "Your account verification is in process. You won’t be able to access your account until verified. You will receive an email once your account status is updated.",
                              text: response.data.message || 'An OTP has send to email for verification',
                              confirmButtonText: 'Continue',
                              confirmButtonColor: '#d33', // Red button
                              allowOutsideClick: false,   
                              allowEscapeKey: false,     
                              allowEnterKey: true         
                            }).then((result) => {
                              if (result.isConfirmed) {
                                //window.location.reload();
                                // Close registration modal if still open
                                const regModalEl = document.getElementById('agentRegistrationModal');
                                const regModal = bootstrap.Modal.getInstance(regModalEl);
                                if (regModal) regModal.hide();

                                // Open OTP modal
                                const otpModalEl = document.getElementById('otpAgentRegisterModal');
                                const otpModal = new bootstrap.Modal(otpModalEl, { keyboard: false, backdrop: 'static' });
                                otpModal.show();

                                // Optional: reset OTP inputs
                                this.otp = Array(5).fill(''); // assuming 6-digit OTP
                                this.errors.otpError = '';
                                this.registeredEmail = response.data.email;
                              }
                            });

                          } else {
                            Swal.fire({
                              title: 'Error',
                              text: response.data.messages
                                ? Object.values(response.data.messages).flat()[0]  // takes first error message
                                  : 'Registration failed. Please try again.',
                                confirmButtonText: 'OK',
                                confirmButtonColor: '#d33', // red button
                            });
                          }
                        } else {
                          Swal.fire({
                            title: 'Error',
                            text: response.data?.message || `Server responded with status ${response.status}`,
                          });
                        }

                      } catch (error) {
                        console.error('Sign up error:', error);
                        // Generic error message
                        Swal.fire({
                          title: 'Something went wrong',
                          text: 'Please check your internet connection or try again later.',
                        });
                      } finally {
                        this.isSignUpLoading = false;
                      }
                    }
                  });
              }
          },

          validateEmail(email) {
              const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              return re.test(email);
          },

          validateAadhar(aadhar) {
            // Remove all non-digit characters
            const digits = aadhar.replace(/\D/g, '');
            // Aadhar must be exactly 12 digits
            return /^[0-9]{12}$/.test(digits);
          },

          // GST Validation Function
          validateGST(gst) {
              // GST format: 2 digits state code + 10 PAN + 1 entity code + 1 Z + 1 checksum
              const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
              return gstRegex.test(gst);
          },

          // Agent sign in
          async handleSignIn() {
              this.errors = {}; // reset errors

              // Validation
              let valid = true;
              if (!this.signInForm.email) {
                this.errors.email = 'Email is required';
                valid = false;
              } else if (!/^\S+@\S+\.\S+$/.test(this.signInForm.email)) {
                this.errors.email = 'Enter a valid email';
                valid = false;
              }

              if (!this.signInForm.password) {
                this.errors.password = 'Password is required';
                valid = false;
              } else if (this.signInForm.password.length < 6) {
                this.errors.password = 'Password must be at least 6 characters';
                valid = false;
              }

              if (!valid) return;

              // Start loading
              this.isLoading = true;

              try {
                // Simulate API call
                //console.log('Signed in with:', this.signInForm);
                const response = await AgentSignIn(this.signInForm);
                ///console.log('Form response:', JSON.stringify(response, null, 2));

                // Check response status
                if (response.status === 200) {
                  ///console.log("Response data:", JSON.stringify(response.data, null, 2));
                              
                  if (response.data.success === true) {
                    Swal.fire({
                      title: 'Login Successful!',
                      text: 'Welcome back! You’re now signed in to your agent account.' || response.data.message,
                      confirmButtonText: 'Continue',
                      confirmButtonColor: '#d33', // Red button
                      allowOutsideClick: false,   
                      allowEscapeKey: false,     
                      allowEnterKey: true         
                    }).then((result) => {
                      if (result.isConfirmed) {
                        //window.location.reload();
                        // Close registration modal if still open
                        const regModalEl = document.getElementById('agentRegistrationModal');
                        const regModal = bootstrap.Modal.getInstance(regModalEl);
                        if (regModal) regModal.hide();
                        // For Login Model
                        const loginModalEl = document.getElementById('agentSignInModal');
                        const loginModal = bootstrap.Modal.getInstance(loginModalEl);
                        if (loginModal) loginModal.hide();

                        const agentStore = useAgentStore();
                        agentStore.clearAgentDetails();
                        agentStore.setAgentDetails(response.data);
                        ///localStorage.setItem('agentDetails', JSON.stringify(response.data));

                        window.location.reload();

                      }
                    });

                  } else {
                    Swal.fire({
                      title: 'Error',
                      text: response.data.messages
                        ? Object.values(response.data.messages).flat()[0]  // takes first error message
                          : 'Sign In failed. Please try again.',
                      confirmButtonText: 'OK',
                      confirmButtonColor: '#d33', // red button
                    });
                  }
                } else {
                  Swal.fire({
                    title: 'Error',
                    text: response.data?.message || `Server responded with status ${response.status}`,
                  });
                }
              } catch (error) {
                console.error(error);
              } finally {
                this.isLoading = false;
              }
          },

          // close otp model
          closeOtpModal() {
            const otpModalEl = document.getElementById('otpAgentRegisterModal');
            const otpModal = bootstrap.Modal.getInstance(otpModalEl);
            if (otpModal) otpModal.hide();

            // Clear timer interval
            clearInterval(this.otpTimerInterval);

            // Remove any leftover backdrop
            //document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
          },

          // Close Registration and show Sign In properly
          closeRegAndOpenSignIn() {
              const regModalEl = document.getElementById('agentRegistrationModal');
              const regModal = bootstrap.Modal.getInstance(regModalEl);

              if (regModal) {
                  // Hide the registration modal
                  regModal.hide();

                  // Wait until fully hidden
                  regModalEl.addEventListener('hidden.bs.modal', () => {
                      const signInModalEl = document.getElementById('agentSignInModal');
                      const signInModal = new bootstrap.Modal(signInModalEl, {
                          backdrop: 'static', // optional
                          keyboard: false     // optional
                      });
                      signInModal.show();
                      window.location.reload();
                  }, { once: true });
              }
          },

          openRegistrationFromSignIn() {
              const signInModalEl = document.getElementById('agentSignInModal');
              const signInModal = bootstrap.Modal.getInstance(signInModalEl);

              if (signInModal) {
                  signInModal.hide();
                  signInModalEl.addEventListener('hidden.bs.modal', () => {
                      const regModalEl = document.getElementById('agentRegistrationModal');
                      const regModal = new bootstrap.Modal(regModalEl);
                      regModal.show();
                  }, { once: true });
              }
          },


          async validationMain(responseEmail) {
              //console.log('responseEmail : ', responseEmail);
              if (this.otpIncomplete) {
                this.errors.otpError = "Please enter the complete OTP.";
                return;
              }

              // Clear previous error
              this.errors.otpError = "";
              this.loading = true;

                const enteredOtp = this.otp.join('');
                try {
                  const res = await AgentVerifyOTP(responseEmail, enteredOtp);
                  ///console.log('OTP Verified-1!', res);
                  ///console.log('OTP Verified-2!', JSON.stringify(res.data, null, 2));
                  if (!res.data.success) {
                      this.errors.otpError = res.data.message || 'Invalid or expired OTP.';
                      return;
                  }

                  Swal.fire({
                      //title: 'OTP Verified!',
                      title: 'Registration Successful!',
                      //text: 'Your account verification is in process. You won’t be able to access your account until verified. You will receive an email once your account status is updated.',
                      text: res.data.message || 'Registration successful! You can now sign in and start using the Agent Portal.',
                      confirmButtonText: 'OK',
                      confirmButtonColor: '#d33',
                      allowOutsideClick: false,   
                      allowEscapeKey: false,     
                      allowEnterKey: true
                  }).then((result) => {
                      if (result.isConfirmed) {
                          // Optional: close OTP modal
                          const otpModalEl = document.getElementById('otpAgentRegisterModal');
                          const otpModal = bootstrap.Modal.getInstance(otpModalEl);
                          if (otpModal) otpModal.hide();

                          // Optional: reset OTP inputs
                          this.otp = Array(5).fill('');
                          this.errors.otpError = '';
                          // Refresh the page
                          window.location.reload();
                      }
                  });

                  // Close OTP modal and navigate
                  this.closeOtpModal();

                } catch (error) {
                    console.error("Axios Error:", error);
                    if (error.response?.data) {
                      this.errors.otpError = error.response.data.message || "Something went wrong.";
                    } else if (error.message) {
                      this.errors.otpError = `Request error: ${error.message}`;
                    } else {
                      this.errors.otpError = "An unknown error occurred.";
                    }
                } finally {
                    this.loading = false;
                }
          },

          resetOtpTimer() {
            if (this.otpTimerInterval) clearInterval(this.otpTimerInterval);
            this.timer = 180; // 3 minutes
            this.updateFormattedTime();
            this.startOtpTimer();
          },

          startOtpTimer() {
            this.updateFormattedTime();
            this.otpTimerInterval = setInterval(() => {
              if (this.timer > 0) {
                this.timer--;
                this.updateFormattedTime();
              } else {
                clearInterval(this.otpTimerInterval);
              }
            }, 1000);
          },

          updateFormattedTime() {
            ///console.log('updateFormattedTime : ');
            const minutes = String(Math.floor(this.timer / 60)).padStart(2, '0');
            const seconds = String(this.timer % 60).padStart(2, '0');
            this.formattedTime = `${minutes}:${seconds}`;
            this.$forceUpdate();
            ///console.log('this.formattedTime : ', this.formattedTime);
          },

          async handleResend(resendEmail) {
            //console.log('hai resend', resendEmail);
            if (this.timer > 0) {
              this.errors.otpError = 'Please wait before resending the OTP.';
              return;
            }

            this.resendloading = true;
            this.errors.otpError = '';
            const purpose = 'Agent';

            try {
              const sendOTP = await AgentOTPResend(resendEmail);

              if (sendOTP.data.success === true) {
                this.resendCount++;
                
                // reset timer properly
                this.resetOtpTimer();
                this.timerActive = true;

                // disable resend temporarily if needed
                if (this.resendCount >= 1) {
                  this.resendDisabled = true;
                  setTimeout(() => {
                    this.resendCount = 0;
                    this.resendDisabled = false;
                  }, 5 * 60 * 1000); // 5 minutes
                }

                this.errors.otpError = '';
              } else {
                this.errors.otpError = sendOTP.data.message || 'Error sending OTP.';
              }
            } catch (error) {
              this.errors.otpError = error?.message || 'Something went wrong.';
            } finally {
              this.resendloading = false;
            }
          },



          // the otp number enter section
          focusNext(index, event) {
            if (event.inputType === 'insertText' && index < this.otp.length - 1) {
              this.$refs.otpInputs[index + 1].focus();
            }
          },
          focusPrev(index, event) {
            if (!this.otp[index] && index > 0) {
              this.$refs.otpInputs[index - 1].focus();
            }
          },

          toggleDropdown() {
            this.showDropdown = !this.showDropdown;
          },

          handleClickOutside(event) {
            if (this.$refs.dropdownRef && !this.$refs.dropdownRef.contains(event.target)) {
              this.showDropdown = false;
            }
          },

          togglePassword() {
            this.showPassword = !this.showPassword;
          },

          checkAgentLogin() {
            const agentStore = useAgentStore();
            agentStore.loadAgentDetails(); 

            if (agentStore.agentDetails) {
              //console.log(' Agent is logged in:', JSON.stringify(agentStore.agentDetails, null, 2));
              this.isAgentLoggedIn = true;
              this.agentName = agentStore.agentDetails?.user?.name || 'Agent';
            } else {
              //console.log(' Agent is not logged in');
              this.isAgentLoggedIn = false;
              this.agentName = '';
            }
          },

          async logoutAgent() {
            //dropdownOpen.value = false;
            const agentStore = useAgentStore();

            try {
              const res = await AgentLogout();

              if (res.data && res.data.success) {
                this.$refs.toast?.showToast('Logout successful!', 'success', 1000); // 1 second
              } else {
                this.$refs.toast?.showToast(res.data.message || 'Logout failed!', 'error', 1000); // 1 second
              }
            } catch (error) {
              if (error.response) {
                this.$refs.toast?.showToast(error.response.data.message || `Error: ${error.response.status}`, 'error', 1000); // 1 second
              } else {
                this.$refs.toast?.showToast('Network or server error!', 'error', 1000); // 1 second
              }
            } finally {
              agentStore.clearAgentDetails();

              // Delay redirect slightly so toast is visible
              setTimeout(() => {
                window.location.reload();
              }, 1200); // slightly longer than toast duration
            }
          }


      }
    
}
</script>